import React from 'react';
import {Grid,Chip} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import {isEmpty} from 'lodash'
import {useSelector, useDispatch} from 'react-redux'
import {onGetMinaChild,getChildKontoUsers,getArtikelTags,getOrderStatusListbyAfid,
    getRinglistorAll
} from 'actions'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
    }
  }));
function ChipsList(props) {
    const dispatch = useDispatch()
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const ChildList = useSelector(state => state.accountsData.ChildList)
    const Kontonamn = useSelector(state => state.accountsData.currentAccount.name)
    const ChildKontoUsers = useSelector(state => state.accountsData.ChildKontoUsers)
    const ArtikelTagsList = useSelector(state => state.ArtikelReg.ArtikelTagsList)
    const OrderStatusList = useSelector(state=>state.accountsData.OrderStatusList)
    const AfDistrikt = useSelector(state => state.accountsData.AfDistrikt)
    const ArendeStatusList = useSelector(state => state.accountsData.ArendeStatusList)
    const FakturaIntervall = useSelector(state => state.accountsData.FakturaIntervall)
    const RingListorA = useSelector(state=>state.RingList.RingListorA)

    const ErrandOption2 = props.intl.formatMessage({ id: 'Errand.Economy.Invoice.option2' });
    const ErrandOption3 = props.intl.formatMessage({ id: 'Errand.Economy.Invoice.option3' });
    const ErrandOption4 = props.intl.formatMessage({ id: 'Errand.Economy.Invoice.option4' });
    const ErrandOption5 = props.intl.formatMessage({ id: 'Errand.Economy.Invoice.option5' });
    const Created = props.intl.formatMessage({ id: 'Created' });
    const DateFrom = props.intl.formatMessage({ id: 'Chips.Date.from' });
    const DateTo = props.intl.formatMessage({ id: 'Chips.Date.to' });
    const KontonLabel = props.intl.formatMessage({ id: 'A.Account' });
    const AnsvarigLabel = props.intl.formatMessage({ id: 'appKontoModule.Owner' });
    const AllLabel = props.intl.formatMessage({ id: 'All' });
    const UserLabel = props.intl.formatMessage({ id: 'User' });
    const ArtikelTaggs = props.intl.formatMessage({ id: 'Chips.Products.Tags' });
    const ProjectTaggs = props.intl.formatMessage({ id: 'Project' });
    const TypeLabel = props.intl.formatMessage({ id: 'Input.Type' });
    const BookedFromLabel = props.intl.formatMessage({ id: 'Chips.Booked.date.from' });
    const BookedToLabel = props.intl.formatMessage({ id: 'Chips.Booked.date.to' });
    const CancelledfromLabel = props.intl.formatMessage({ id: 'Chips.Cancelled.date.from' });
    const CancelledToLabel = props.intl.formatMessage({ id: 'Chips.Cancelled.date.to' });
    const StartFromLabel = props.intl.formatMessage({ id: 'Chips.start.from' });
    const StartToLabel = props.intl.formatMessage({ id: 'Chips.start.to' });
    const PeriodfromLabel = props.intl.formatMessage({ id: 'Chips.period.date.from' });
    const PeriodtoLabel = props.intl.formatMessage({ id: 'Chips.period.date.to' });
    const RenegotiationfromLabel = props.intl.formatMessage({ id: 'Chips.Renegotiation.date.from' });
    const RenegotiationtoLabel = props.intl.formatMessage({ id: 'Chips.Renegotiation.date.to' });
    const StatusLabel = props.intl.formatMessage({ id: 'Table.Status' });
    const InvoiceLabel = props.intl.formatMessage({ id: 'Errand.Economy.Invoice' });
    const CTagsLabel = props.intl.formatMessage({ id: 'Chips.customers.Tags' });
    const CDataLabel = props.intl.formatMessage({ id: 'Customer.Data' });
    const CStatusLabel = props.intl.formatMessage({ id: 'Chips.customers.Status' });
    const WonGoingLabel = props.intl.formatMessage({ id: 'Chips.With.onGoing' });
    const CreateddatumFLabel = props.intl.formatMessage({ id: 'Chips.Createddatum.from' });
    const CreateddatumTLabel = props.intl.formatMessage({ id: 'Chips.Createddatum.to' });
    const RegddatumFLabel = props.intl.formatMessage({ id: 'Chips.Reg.date.from' });
    const RegdatumTLabel = props.intl.formatMessage({ id: 'Chips.Reg.date.to' });
    const WSupplierLabel = props.intl.formatMessage({ id: 'Chips.With.Supplier' });
    const InvoiceSLabel = props.intl.formatMessage({ id: 'input.invoice.Options' });
    const NoLabel = props.intl.formatMessage({ id: 'Option.No' });
    const YesLabel = props.intl.formatMessage({ id: 'Option.Yes' });
    const monthLabel = props.intl.formatMessage({ id: 'month.lowerCase' });
    const InvoicingLabel = props.intl.formatMessage({ id: 'Invoicing' });
    const OrderItemsLabel = props.intl.formatMessage({ id: 'Chips.Order.Items' });
    const RinglistaLabel = props.intl.formatMessage({ id: 'Calling.list' });
    const ProjectTidPaxmlLabel = props.intl.formatMessage({ id: 'Chips.Project.Time.Paxml' });
    const LatestEventLabelto = props.intl.formatMessage({ id: 'Chips.Reports.Latest.events.to' });
    const LatestEventLabelfrom = props.intl.formatMessage({ id: 'Chips.Reports.Latest.events.from' });




    React.useEffect(()=>{
         dispatch(getRinglistorAll(Afid,userid))
        if(isEmpty(ChildList)){
            dispatch(onGetMinaChild(Afid))
            if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
                const Konto = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
                dispatch(getChildKontoUsers(Afid,userid,Konto))
                dispatch(getOrderStatusListbyAfid(parseInt(Konto) === -1? Afid:Konto,1))
            }
        }
        if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Artikel_Etiketter"}))){
            dispatch(getArtikelTags(Afid,userid))
        }       
    },[])
    const classes = useStyles();
    const GetMeta =(Meta)=>{
        switch(Meta){
            case "ansvarig":return AnsvarigLabel
            case "Rapport":return TypeLabel
            case "DatumFrom":return DateFrom
            case "DatumTo":return DateTo
            case "bokadDatumFrom":return BookedFromLabel
            case "bokadDatumTo":return BookedToLabel
            case "AvbokadDatumFrom":return CancelledfromLabel
            case "AvbokadDatumTo":return CancelledToLabel
            case "StartDatumAvtalFrom":return StartFromLabel
            case "StartDatumAvtalTo":return StartToLabel
            case "StartDatumFrom":return PeriodfromLabel
            case "StartDatumTo":return PeriodtoLabel
            case "OmforDatumFrom":return RenegotiationfromLabel
            case "OmforDatumTo":return RenegotiationtoLabel
            case "ArendeStatus":return StatusLabel
            case "EsigneringStatus":return StatusLabel
            case "ArendeFaktura":return InvoiceLabel
            case "ArendeTyp":return TypeLabel
            case "AvtalToken":return StatusLabel
            case "ProspektToken":return StatusLabel
            case "Projekt":return ProjectTaggs
            case "KundsTaggar":return CTagsLabel
            case "KontonUser":return AnsvarigLabel
            case "Kunddatatyp":return CDataLabel
            case "Konton":return KontonLabel
            case "Kundstatus":return CStatusLabel
            case "OrderStatus":return StatusLabel
            case "Artikel_Etiketter":return ArtikelTaggs
            case "MedLopande":return WonGoingLabel
            case "SkapadDatumFrom":return CreateddatumFLabel
            case "SkapadDatumTo":return CreateddatumTLabel
            case "RegDatumFrom":return RegddatumFLabel
            case "RegDatumTo":return RegdatumTLabel
            case "WithLeverantor":return WSupplierLabel
            case "Fakturaintervall":return InvoiceSLabel
            case "Ringlista":return RinglistaLabel
            case "SenasEventDatumTo":return LatestEventLabelto
            case "SenasEventDatumFrom":return LatestEventLabelfrom
            default:return Meta
        }
    }
    const GetValue =(n)=>{
        switch(n.Meta){
            case "ansvarig":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }
                else{
                    const UserObject = props.Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "DatumFrom":return  n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "DatumTo":return  n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "bokadDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "bokadDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "AvbokadDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "AvbokadDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumAvtalFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumAvtalTo":return moment(n.Value).format("YYYY-MM-DD")
            case "OmforDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "OmforDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "SenasEventDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "SenasEventDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "SkapadDatumTo":return n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "SkapadDatumFrom":return n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "ArendeStatus":return getArendeStatus(n.Value)
            case "ArendeFaktura":return getArendefaktura(n.Value)
            case "AvtalToken":return getAvtalToken(n.Value)
            case "ProspektToken":return getProspektToken(n.Value)
            case "KundsTaggar":return getKundsTaggar(n.Value)
            case "Konton":return getKontonNamn(n.Value)
            case "KontonUser":return getKontonUser(n.Value)
            case "Artikel_Etiketter":return getArtikelEtiketter(n.Value)
            case "Kundstatus":return getKundstatus(n.Value)
            case "Projekt":return n.Value.ProjectName
            case "Kund":return n.Value.label
            case "Rapport":return getRapportName(n.Value)
            case "OrderStatus":return getOrderStatus(n.Value)
            case "EsigneringStatus":return getEsigneringStatus(n.Value)
            case "MedLopande":return getMedLopande(n.Value)
            case "WithLeverantor":return parseInt(n.Value) === 0?NoLabel:YesLabel
            case "Fakturaintervall":return `${parseInt(n.Value)} ${monthLabel}`
            case "Distrikt":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    try{
                    return AfDistrikt.filter(item=>{return item.id === parseInt(n.Value)})[0].Name
                    }
                    catch(err){
                       return ''
                    }
                }
            case "Ringlista":return getRinglista(n.Value)
            default: return `${n.Value}`
        }
    }
    const getRinglista = (n)=>{
        let Ringlist = RingListorA.find(item=>parseInt(item.id) === parseInt(n))?.KampanjName
        return Ringlist
    }
    const handleDelete=(n)=>{
        props.handleDeleteOptions(n)
    }
    const getRapportName=(Value)=>{
        switch(Value){
            case "Order artiklar":return OrderItemsLabel
            case "Avtalsfakturering":return InvoicingLabel
            case "ProjectTidPaxml": return ProjectTidPaxmlLabel
            default:return Value
        }
    }
    const getArendeStatus=(Value)=>{
      if(isEmpty(ArendeStatusList)){
        switch(Value){
          case "1": return props.intl.formatMessage({ id: 'input.status.option1' })
          case "2": return props.intl.formatMessage({ id: 'input.status.option2' })
          case "3": return props.intl.formatMessage({ id: 'input.status.option4' })
          case "4": return props.intl.formatMessage({ id: 'input.status.option5' })
          case "5": return props.intl.formatMessage({ id: 'input.status.option3' })
        }
      }   
      else{   
          //
          let Afif  =Afid
          if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
              Afif = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
          }
          let Sttsta=isEmpty(ArendeStatusList)?[{Meta:""}]:ArendeStatusList.filter(item=>{
              return parseInt(item.Value) === parseInt(Value)
          }) 
          return isEmpty(Sttsta)?"":Sttsta[0].Meta        
      }
    }
    const getArendefaktura=(Value)=>{
      switch(parseInt(Value)){
          case 2: return ErrandOption2
          case 3: return ErrandOption3
          case 4: return ErrandOption4
          case 5: return ErrandOption5
      }
  }
    const getMedLopande=(Value)=>{
        switch(parseInt(Value)){
            case 1:return YesLabel
            case 2:return NoLabel
            default:return YesLabel
        }
    }
    const getEsigneringStatus=(Value)=>{
        switch(parseInt(Value)){
            case 0: return Created
            case 2: return props.intl.formatMessage({ id: 'Label.Sent' })
            case 3: return props.intl.formatMessage({ id: 'Label.Shown' })
            case 5: return props.intl.formatMessage({ id: 'Label.Singed' })
            case 1: return props.intl.formatMessage({ id: 'Label.Recalled' })
            case 4: return props.intl.formatMessage({ id: 'Label.Timeout' })
            case 7: return props.intl.formatMessage({ id: 'Label.Rejected' })
            case 6: return props.intl.formatMessage({ id: 'Label.Rejected' })
        }
    }
    const getOrderStatus=(Value)=>{
        if(isEmpty(OrderStatusList)){
            switch(Value){
                case "1": return props.intl.formatMessage({ id: 'Label.Draft' })
                case "2": return props.intl.formatMessage({ id: 'Order.status.new' })
                case "3": return props.intl.formatMessage({ id: 'Order.status.processed' })
                case "4": return props.intl.formatMessage({ id: 'Order.status.supplemented' })
                case "5": return props.intl.formatMessage({ id: 'Done' })
            }
            }   
            else{   
                //
                let Afif  =Afid
                if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
                    Afif = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
                }
                let Sttsta=isEmpty(OrderStatusList)?[{Meta:""}]:OrderStatusList.filter(item=>{
                    return parseInt(item.Value) === parseInt(Value)
                }) 
                return isEmpty(Sttsta)?"":Sttsta[0].Meta        
            }
        /*
        switch(parseInt(Value)){
            case 1:return "Behandlas"
            case 2:return "Klar"
        }
        */
    }
    const getKundstatus=(Value)=>{
        switch(parseInt(Value)){
            case 1:return props.intl.formatMessage({ id: 'Customer.Status1' })
            case 2:return props.intl.formatMessage({ id: 'Customer.Status2' })
            case 3:return props.intl.formatMessage({ id: 'Customer.Status3' })
            case 4:return props.intl.formatMessage({ id: 'Customer.Status4' })
        }
    }
    const getAvtalToken=(Value)=>{
        switch(parseInt(Value)){
            case 1:return props.intl.formatMessage({ id: 'Existing' })
            case 2:return props.intl.formatMessage({ id: 'Completed' })
            case 3:return AllLabel
        }
    }
    const getProspektToken=(Value)=>{
        switch(parseInt(Value)){
            case 1:return props.intl.formatMessage({ id: 'Existing' })
            case 2:return props.intl.formatMessage({ id: 'Label.Lost' })
            case 4:return props.intl.formatMessage({ id: 'Chips.Deleted' })
            case 3:return AllLabel
        }
    }
    const getKundsTaggar=(Value)=>{
        if(Value.toString()  === '-1'){
            return AllLabel
        }else{
            return Value
        }
    }
    const getKontonNamn=(Value)=>{
        if(Value.toString()  === '-1'){
            return AllLabel
        }
        else if(parseInt(Afid) === parseInt(Value)){
            return Kontonamn
        }
        else{
            console.log(ChildList,"ASD")
            let Konto =isEmpty(ChildList)?"":ChildList.filter(item => {return parseInt(item.ChildAfid) === parseInt(Value)})[0].name
            return Konto
        }
    }
    const getKontonUser=(Value)=>{
        if(Value.toString()  === '-1'){
            return AllLabel
        }
        else{
            let Konto = isEmpty(ChildKontoUsers)?"":ChildKontoUsers.filter(item => {return parseInt(item.id) === parseInt(Value)})
            let name = isEmpty(Konto)?UserLabel:`${Konto[0].FirstName} ${isEmpty(Konto[0].LastName)?"":Konto[0].LastName}`
            return name
        }
    }
    const getArtikelEtiketter=(Value)=>{
        if(Value.toString()  === '-1'){
            return AllLabel
        }
        else{
            let Keyword =isEmpty(ArtikelTagsList)?"":ArtikelTagsList.filter(item => {return parseInt(item.id) === parseInt(Value)})[0].Keyword
            return Keyword
        }
    }
    console.log(props.Chips)
    return (
        <Grid container className={classes.root} spacing={2}>
           {    
                isEmpty(props.Chips)?"":
               props.Chips.map((n,index)=>{
                   return (
                    <Grid item key={index}>
                        <Chip 
                        color="primary" 
                        size="small" 
                        style={{background:"#0c969c", color:"#fff",borderRadius:"0"}}
                        label={`${GetMeta(n.Meta)}: ${GetValue(n)}`}
                        onDelete={()=>handleDelete(n)} 
                        />
                    </Grid>
                   )
               })
           } 
        </Grid>
    );
}

export default injectIntl(ChipsList);
